"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledAppContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;

  .Polaris-ButtonGroup {
    display: block;
  }

  @media ${config_1.device.laptop} {
    .Polaris-ButtonGroup {
      display: flex;
    }
  }
`;
